import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = ({ targetRef }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // força esperar render/layout
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // scroll da window
        window.scrollTo({ top: 0, behavior: "smooth"});

        // scroll do container interno
        if (targetRef?.current) {
          targetRef.current.scrollTop = 0;
          targetRef.current.behavior = "smooth"
        }
      });
    });
  }, [pathname, targetRef]);

  return null;
};
